// Pure hysteresis decision for the responsive tab-collapse trigger.
//
// When expanded, collapse to icon-only the moment the full-label nav
// would overflow its wrapper cell, and remember the viewport width at
// that moment. When collapsed, re-expand only once the viewport is
// meaningfully wider than that remembered width (by `hysteresisPx`).
//
// The re-expand check deliberately ignores the wrap/nav widths: the
// brand collapses in lockstep and hands the tabs cell ~50px back, so a
// width-based re-expand check would immediately re-collapse and
// oscillate. The viewport width is the stable signal.
export interface TabCollapseInput {
  iconOnly: boolean;
  vw: number;             // viewport width now
  collapseAtVw: number;   // viewport width remembered at last collapse
  wrapWidth: number;      // tabs wrapper cell clientWidth
  navScrollWidth: number; // full-label nav scrollWidth
  hysteresisPx: number;
}

export interface TabCollapseState {
  iconOnly: boolean;
  collapseAtVw: number;
}

export function nextTabCollapseState(input: TabCollapseInput): TabCollapseState {
  const { iconOnly, vw, collapseAtVw, wrapWidth, navScrollWidth, hysteresisPx } = input;
  if (iconOnly) {
    if (vw >= collapseAtVw + hysteresisPx) return { iconOnly: false, collapseAtVw };
    return { iconOnly: true, collapseAtVw };
  }
  if (wrapWidth < navScrollWidth) return { iconOnly: true, collapseAtVw: vw };
  return { iconOnly: false, collapseAtVw };
}
